import * as React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const Breadcrumbs = ({ sticky, withHomepage, children }) => (
  // <div className={classNames(sticky ? 'sticky' : '', 'top-0 z-10 bg-gray-200')}>
  <div className="bg-gray-200">
    <ul className="max-w-2xl p-4 mx-auto tracking-tight text-center text-gray-600 breadcrumb sm:px-6 lg:max-w-7xl lg:px-8">
      {withHomepage && (
        <li>
          <Link to="/">Startseite</Link>
        </li>
      )}
      {children}
    </ul>
  </div>
)

export default Breadcrumbs

Breadcrumbs.propTypes = {
  sticky: PropTypes.bool,
  withHomepage: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
}
